import { SET_COMPETITION_ID } from "./actionTypes";

const CompetitionSelectActions = {
  setCompetition(competition, competitionSelectId) {
    return { type: SET_COMPETITION_ID, competition, competitionSelectId };
  },
};

export { CompetitionSelectActions };
